<section>
  <div class="row mx-0" [hidden]="!isFormView">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
      <app-register-charge-account-detail [chargeAccountModel]="chargeAccountModel"
        [chargeAccountDetailContract]="chargeAccountDetail" (updateListDetail)="getUpdateListDetail()"
        (chargeAccountContract)="getChargeAccount($event)"
        (isFormView)="getFormView($event)"></app-register-charge-account-detail>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
    <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
      [showCheckbox]="!disabledButton" [checkBoxAction]="checkboxActions"
      [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getDetailsChargeAccountWithPagination()"
      [limitHidden]="true" (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
    </app-custom-table>
  </div>
</section>